import { cn } from '@/lib/utils';

export default function H4({ children, className }: { children: string; className?: string }) {
    return <h4 className={cn('text-h5 font-normal lg:text-h4 lg:font-medium', className)}>{children}</h4>;
}
